<template>
    <rkm-form ref="Form">
        <rkm-area
            type="section"
            title="Buscar jornadas cadastradas"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="jornada.periodo"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário Inicial"
                        v-model="jornada.horaInicial"
                        :validations="jornada.horaFim ? validations.horaInicial: {}"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário Final"
                        v-model="jornada.horaFim"
                        :validations="jornada.horaInicial ? validations.horaFim: {}"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Número de vagas"
                        number
                        v-model="jornada.vagas"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.unidadesParametrizadas"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="jornada.unidadeId"
                        default-option-text="Selecione"
                        value-field="unidadeId"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="jornada.infraestruturaId"
                        valueField="id"
                        show-default-option
                        :disabled="!jornada.unidadeId"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Status"
                        :options="form.status"
                        v-model="jornada.statusId"
                        value-field="id"
                        text-field="nome"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Grupo de exames"
                        :options="form.exames"
                        v-model="jornada.exameId"
                        value-field="id"
                        text-field="nome"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Tipo de jornada"
                        :options="form.tipos"
                        v-model="jornada.tipoId"
                        value-field="id"
                        text-field="nome"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Prestador"
                        :options="form.prestadores"
                        v-model="jornada.prestadorId"
                        value-field="prestadorId"
                        text-field="nomeFantasia"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="8">
                    <rkm-form-checkbox-group
                        label="Dias da semana"
                        v-model="jornada.diasSemana"
                        :options="form.diasSemana"
                        :validations="validations.diasSemana"
                        text-field="nome"
                        value-field="id"
                        buttons
                        button-color="outline-primary"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-button
                        :label="false"
                        @click.stop="resetForm"
                        color="secondary"
                        class="float-right"
                    >
                        Limpar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(search)"
                        color="primary"
                        class="mr-2 float-right"
                    >
                        Buscar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>
     </rkm-form>
</template>

<script>

// Enuns.
import tipoJornada from '@/enums/exame-imagem/tipoJornada'

// Moment.
import moment from 'moment'

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

export default {
    computed:{
        infraestruturas() {

            if (this.jornada.unidadeId) {

                let infraestruturaPrincipal = this.form.unidadesParametrizadas.find(u => u.unidadeId === this.jornada.unidadeId).infraestruturas

                    this.getPrincipal(infraestruturaPrincipal)

                return infraestruturaPrincipal
            }

            return []
        },
        validations() {
            return {
                diasSemana: { required: true },
                horaInicial: { required: true },
                horaFim: { required: true },
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
    },
    created() {

        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada'),
            parametrizacaoExame: this.getConectaSusRepository('exameImagem.parametrizacao')
        }
    },
    data:() => ({
        jornada: {
            data: null,
            exameId: null,
            exameNome: '',
            horaInicial: '',
            horaFim: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            diasSemana:null,
            semanaId: null,
            statusId: null,
            statusNome: '',
            tempoAtendimento: '',
            tipoId: null,
            tipoNome: null,
            unidadeId: null,
            unidadeNome: '',
            usuarioId: '',
            vagas: '',
            periodo: {
                start: null,
                end: null,
            },
            prestadorId: null,
            prestadorNome: '',
            selecionado: false,
        },
        enums: {
            tipoJornada
        },
        dataAtual: '',
    }),
    methods:{
        ...mapActions(['setLoading', 'unsetLoading']),
        getPrincipal(infraestruturaPrincipal) {

            let localAtendimento = infraestruturaPrincipal.find(u => u.principal === true)

            if(localAtendimento ){

                this.jornada.infraestruturaId = localAtendimento.id
            } else {

                this.jornada.infraestruturaId = null
            }
        },
        search() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                        let buscaJornada = []

                        this.jornada.diasSemana.forEach(diasSemana => {

                            this.model.jornadas.filter(a => a.semanaId == diasSemana).map(aplicacao => {

                                buscaJornada.push(aplicacao)
                            })
                        })

                        if (this.jornada.vagas){
                            buscaJornada = buscaJornada.filter(jornada => jornada.vagas == this.jornada.vagas)
                        }

                        if(this.jornada.unidadeId){
                            buscaJornada = buscaJornada.filter(jornada => jornada.unidadeId == this.jornada.unidadeId)
                        }

                        if (this.jornada.statusId){
                            buscaJornada = buscaJornada.filter(jornada => jornada.statusId == this.jornada.statusId)
                        }

                        if (this.jornada.exameId){
                            buscaJornada = buscaJornada.filter(jornada => jornada.exameId == this.jornada.exameId)
                        }

                        if (this.jornada.tipoId){
                            buscaJornada = buscaJornada.filter(jornada => jornada.tipoId == this.jornada.tipoId)
                        }

                        if (this.jornada.prestadorId){
                            buscaJornada = buscaJornada.filter(jornada => jornada.prestadorId == this.jornada.prestadorId)
                        }

                        if (this.jornada.horaInicial && this.jornada.horaFim){

                            const horaDigitadaInicial = this.jornada.horaInicial.substr(0, 5)
                            const horaDigitadaFinal = this.jornada.horaFim.substr(0, 5)

                            const getMoment = (data, hora) => moment(`${data} ${hora}`, 'YYYY-MM-DD HH:mm')

                            buscaJornada = buscaJornada.filter(jornada => (
                                getMoment(jornada.data, jornada.horaInicial) >= getMoment(jornada.data, horaDigitadaInicial)
                                && getMoment(jornada.data, jornada.horaInicial) <= getMoment(jornada.data, horaDigitadaFinal)
                            ) || (
                                getMoment(jornada.data, jornada.horaFim) >= getMoment(jornada.data, horaDigitadaInicial)
                                && getMoment(jornada.data, jornada.horaFim) <= getMoment(jornada.data, horaDigitadaFinal)
                            ))

                        }

                        if (this.jornada.periodo){

                            const start = moment(this.jornada.periodo.start).subtract(1, 'day')
                            const end = moment(this.jornada.periodo.end).add(1, 'day')

                            buscaJornada = buscaJornada.filter(jornada => moment(jornada.data, 'YYYY-MM-DD').isBetween(start, end))
                        }

                        this.model.jornadasNotSave = buscaJornada
                        this.$emit('handleBlur')
                })
        },
        resetForm() {

            this.jornada.vagas = ''
            this.jornada.statusId = null
            this.jornada.horaInicial = ''
            this.jornada.horaFim = ''
            this.jornada.unidadeId = null
            this.jornada.infraestruturaId = null
            this.jornada.selecionado = false
            this.jornada.tipoId = null
            this.jornada.exameId = null
            this.jornada.prestadorId = null
            this.jornada.periodo.start = null
            this.jornada.periodo.end = null

            this.model.jornadasNotSave = null

            this.$emit('handleBlur')

            this.$nextTick()
                .then(() => {

                    this.$refs.Form.resetValidator()
                })
        },
        validate() {
            return this.$refs.Form.validate()
        },
        disabledSemanas(){

            this.form.diasSemana.forEach(s => s.disabled = false)
        }
    },
    mixins: [ repository, error, object, data, stringCase ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        profissional: { type: Object, required: true},
    },
    watch: {
        'jornada.periodo': {
            deep: true,
            handler: function (periodo) {

                this.jornada.diasSemana = []
                this.disabledSemanas()

                if(periodo.end){

                    var periodoInicial = moment(periodo.start, 'YYYY/MM/DD');
                    var periodoFinal = moment(periodo.end, 'YYYY/MM/DD');

                    var diaInicial   = periodoInicial.format('D');
                    var mesInicial = periodoInicial.format('M');
                    var anoInicial  = periodoInicial.format('YYYY');

                    var diaFinal   = periodoFinal.format('D');
                    var mesFinal = periodoFinal.format('M');
                    var anoFinal  = periodoFinal.format('YYYY');

                    var dataInicial = new Date(anoInicial,mesInicial - 1,diaInicial);
                    var dataFim = new Date(anoFinal,mesFinal -1 ,diaFinal);

                    for (var dataInserida = dataInicial; dataInserida <= dataFim; dataInserida.setDate(dataInserida.getDate() + 1)) {

                        var data = moment(dataInserida, 'DD/MM/YYYY').toDate()

                        var dia = data.getDay() + 1;

                        if(!this.jornada.diasSemana.find(d => d == dia)){

                            this.jornada.diasSemana.push(dia)
                        }
                    }

                } else {

                    if(periodo.start){

                        var dataStart = moment(periodo.start, 'DD/MM/YYYY').toDate()

                        var diaStart = dataStart.getDay() + 1;

                        if(!this.jornada.diasSemana.find(d => d == diaStart)){

                            this.jornada.diasSemana.push(diaStart)
                        }
                    }
                }

                if(periodo.start || periodo.end){

                    let indices = []

                    if(periodo.start){

                        let dataStart = moment(periodo.start, 'DD/MM/YYYY').toDate()
                        const index = this.form.diasSemana.findIndex(d => d.id == dataStart.getDay() + 1)
                        indices.push(index)
                    }

                    if(periodo.end){

                        let dataEnd = moment(periodo.end, 'DD/MM/YYYY').toDate()
                        const index = this.form.diasSemana.findIndex(d => d.id == dataEnd.getDay() + 1)
                        indices.push(index)
                    }

                    if(periodo.start && periodo.end){

                        indices = []

                        let dataStart = moment(periodo.start, 'DD/MM/YYYY')
                        let dataEnd = moment(periodo.end, 'DD/MM/YYYY')

                        let indice = 0

                        while (dataStart.isSameOrBefore(dataEnd) && indice < 7) {

                            const index = this.form.diasSemana.findIndex(d => d.id == dataStart.toDate().getDay() + 1)
                            indices.push(index)

                            dataStart.add(1, 'd')

                            indice++
                        }
                    }
                }
            }
        }
    }
}
</script>